/**
 * Hover animation variants for Framer Motion
 */

// Hover animations
export const hoverLift = {
  whileHover: { 
    y: -5,
    transition: { duration: 0.2 }
  },
  whileTap: { 
    y: 0,
    transition: { duration: 0.1 }
  }
};

export const hoverScale = {
  whileHover: { 
    scale: 1.05,
    transition: { duration: 0.2 }
  },
  whileTap: { 
    scale: 0.95,
    transition: { duration: 0.1 }
  }
};

export const hoverScaleLarge = {
  whileHover: { 
    scale: 1.1,
    transition: { duration: 0.2 }
  },
  whileTap: { 
    scale: 0.9,
    transition: { duration: 0.1 }
  }
};

export const hoverRotate = {
  whileHover: { 
    rotate: 5,
    transition: { duration: 0.2 }
  },
  whileTap: { 
    rotate: 0,
    transition: { duration: 0.1 }
  }
};

export const hoverGlow = {
  whileHover: {
    boxShadow: "0 0 20px rgba(70, 112, 191, 0.3)",
    transition: { duration: 0.2 }
  }
};

export const hoverSlide = {
  whileHover: { 
    x: 5,
    transition: { duration: 0.2 }
  },
  whileTap: { 
    x: 0,
    transition: { duration: 0.1 }
  }
};
